module.exports = __webpack_public_path__ + "img/logo.a33dfdf4.png";